__turbopack_context__.v({
  "answer": "_0LPkPq_answer",
  "heading": "_0LPkPq_heading",
  "item": "_0LPkPq_item",
  "list": "_0LPkPq_list",
  "section": "_0LPkPq_section",
});
